const customerRoutes = [
    {
        path: "/customer/activity",
        name: "customerActivity",
        component: () =>
            import(
        /*webpackChunkName: 'component-customer-activity' */ "@/pages/customer/ActivityPage.vue"
            ),
        meta: {
            requiresRole: ["ROLE_ACCESS_CUSTOMERFRONTEND", "ROLE_ACCESS_ADMINFRONTEND"],
        },
    },
    {
        path: "/customer/calls",
        name: "customerCalls",
        component: () =>
            import(
        /*webpackChunkName: 'component-customer-calls' */ "@/pages/customer/CallsPage.vue"
            ),
        meta: {
            requiresRole: ["ROLE_ACCESS_CUSTOMERFRONTEND", "ROLE_ACCESS_ADMINFRONTEND"],
        },
    },
    {
        path: "/customer/answers",
        name: "customerAnswers",
        component: () =>
            import(
        /*webpackChunkName: 'component-customer-answers' */ "@/pages/customer/AnswersPage.vue"
            ),
        meta: {
            requiresRole: ["ROLE_ACCESS_CUSTOMERFRONTEND", "ROLE_ACCESS_ADMINFRONTEND"],
        },
        pros: true,
    },
    {
        path: "/customer/forward",
        name: "customerForwarding",
        component: () =>
            import(
        /*webpackChunkName: 'component-customer-forward' */ "@/pages/customer/ForwardPage.vue"
            ),
        meta: {
            requiresRole: ["ROLE_ACCESS_CUSTOMERFRONTEND", "ROLE_ACCESS_ADMINFRONTEND"],
        },
    },
    {
        path: "/customer/settings",
        name: "customerSettings",
        component: () =>
            import(
        /*webpackChunkName: 'component-customer-settings' */ "@/pages/customer/SettingsPage.vue"
            ),
        meta: {
            requiresRole: ["ROLE_ACCESS_CUSTOMERFRONTEND", "ROLE_ACCESS_ADMINFRONTEND"],
        },
    },
    {
        path: "/customer/mdsConfiguration",
        name: "mdsConfiguration",
        component: () =>
            import(
                /*webpackChunkName: 'component-customer-configuration' */ "@/pages/customer/MdsConfigurationPage.vue"
            ),
        meta: {
            requiresRole: ["ROLE_ACCESS_CUSTOMERFRONTEND", "ROLE_ACCESS_ADMINFRONTEND"],
        },
    },
];

export default customerRoutes;
